module.exports = __webpack_public_path__ + "img/tag.9317bc9d.svg";